import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';

export default {
  name: "positionDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      positionData: null,
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      currency: '',
    };
  },

  methods: {
    getPositionDetail() {
      this.isLoading = true;
      axios.get('/position/detail/' + this.$route.params.id)
      .then((response) => {
        if (response.data.success == true) {
          let data = response.data.data;
          this.positionData = data.positions
          this.currency = data.currency
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error(err);
        }
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    showList() {
      this.$router.push({
        name: "positionList"
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPositionDetail();
  },
};
